import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import { db, storage, } from './firebase';
import firebase from "firebase";
import './imageUpload.css'


function ImageUpload({ username }) {
    const [caption, setCaption] = useState("");
    const [image, setImage] = useState(null);
    const [progress, setProgress] = useState(0);


    const handleChange = (e) => {
        if (e.target.files[0]) {
            setImage(e.target.files[0]);
        }
    };
    const handleUpload = (e) => {
        const uploadTask = storage.ref(`images/${image.name}`).put(image);
        uploadTask.on(
            "state_changed",
            (snapshot) => {
                const progress = Math.round(
                    (snapshot.bytesTransffered / snapshot.totalBytes) * 100

                );
                setProgress(Number.parseInt(progress))
            },
            (error) => {
                alert(error.message)
            },
            () => {
               
                storage
                    .ref("images")
                    .child(image.name)
                    .getDownloadURL()
                    .then(url => {
                        db.collection('posts').add({
                            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                            caption: caption,
                            imageUrl: url,
                            username: username,
                        });
                        setProgress(0);
                        setCaption("");
                        setImage(null);
                    });
            }
        )
    };




    return (
        <div className="imageupload">
            
            <progress className = 'imageupload_progress' value={Number.parseInt(progress)} max="100"/>
            <input type="text" placeholder="Type something..." onChange={event => setCaption(event.target.value)} value={caption} />
            <input type="file" onChange={handleChange} />
            <Button onClick={handleUpload}>Upload</Button>
        </div>
    );
}

export default ImageUpload   